/* 代码高亮样式 */
.response-content pre {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  padding: 1rem;
  overflow-x: auto;
  margin: 1rem 0;
  position: relative;
  border-left: 3px solid var(--accent-color);
}

.response-content code {
  font-family: 'Fira Code', 'Roboto Mono', monospace;
  font-size: 0.9rem;
  line-height: 1.5;
  color: var(--text-color);
  white-space: pre;
  display: block;
}

/* Manim语法关键字高亮 */
.manim-keyword {
  color: #569cd6; /* 蓝色 */
  font-weight: bold;
}

.manim-class {
  color: #4ec9b0; /* 青色 */
}

.manim-function {
  color: #dcdcaa; /* 黄色 */
}

.manim-method {
  color: #9cdcfe; /* 浅蓝色 */
}

.manim-string {
  color: #ce9178; /* 橙色 */
}

.manim-comment {
  color: #6a9955; /* 绿色 */
  font-style: italic;
}

.manim-number {
  color: #b5cea8; /* 浅绿色 */
}

/* 行号容器 */
.code-with-line-numbers {
  counter-reset: line;
  padding-left: 3.5rem;
  position: relative;
}

/* 行号样式 */
.code-line {
  position: relative;
  padding-left: 0.5rem;
  min-height: 1.5rem;
  line-height: 1.5rem;
  margin: 0;
  white-space: pre;
  counter-increment: line;
}

.code-line::before {
  content: counter(line);
  position: absolute;
  left: -3rem;
  width: 2.5rem;
  text-align: right;
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.85rem;
}

/* 高亮当前行 */
.code-line.highlight {
  background-color: rgba(255, 255, 255, 0.1);
  border-left: 2px solid var(--accent-color);
}

/* 代码容器悬停时的样式变化 */
.response-content pre:hover .code-line::before {
  color: rgba(255, 255, 255, 0.6);
}

/* 代码语言标签 */
.code-language {
  position: absolute;
  top: 0;
  right: 0;
  background-color: var(--accent-color);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 0 6px 0 6px;
  font-size: 0.8rem;
  font-weight: bold;
  z-index: 1;
}

/* 复制按钮 */
.copy-code-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: transparent;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 1rem;
  padding: 0.25rem;
  opacity: 0.5;
  transition: opacity 0.2s;
  z-index: 2;
}

.copy-code-btn:hover {
  opacity: 1;
  color: white;
} 

/* 解题模式 Markdown + KaTeX 排版 */
.solve-stream {
  font-size: 16px;
  line-height: 1.8;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  padding: 1rem 2rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: var(--text-color, #1f1f1f);
  white-space: normal;
}
.solve-stream h1,
.solve-stream h2,
.solve-stream h3,
.solve-stream h4 {
  margin: 1rem 0 0.5rem;
  text-align: center;
  color: var(--hm-ink, #202124);
}
.solve-stream p { 
  margin: 0.6rem 0; 
  text-align: left;
  max-width: 100%;
  color: var(--text-color, #1f1f1f);
}
.solve-stream ul,
.solve-stream ol { 
  padding-left: 1.25rem; 
  text-align: left;
  max-width: 100%;
  color: var(--text-color, #1f1f1f);
}
.solve-stream blockquote {
  margin: 1rem 0;
  padding: 0.75rem 1rem;
  border-left: 4px solid var(--accent-color, #1a73e8);
  background: rgba(26, 115, 232, 0.05);
  border-radius: 6px;
  text-align: left;
  color: var(--text-color, #1f1f1f);
}
.solve-stream code { 
  display: inline; 
  white-space: pre-wrap; 
  padding: 0.15rem 0.35rem; 
  background: rgba(0, 0, 0, 0.05); 
  color: #b31412;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 4px; 
}
.solve-stream pre { 
  white-space: pre-wrap; 
  text-align: left;
  background: rgba(0, 0, 0, 0.03);
  padding: 0.75rem 1rem;
  border-radius: 6px;
}

/* KaTeX 公式块置中并留白 */
.solve-stream .katex-display { 
  margin: 1rem auto; 
  overflow-x: auto; 
  text-align: center;
  color: var(--text-color, #1f1f1f);
}
.solve-stream .katex { 
  font-size: 1.06em; 
  color: var(--text-color, #1f1f1f);
}
.solve-stream .katex-error {
  color: #d93025 !important;
  background: rgba(217, 48, 37, 0.08);
  border: 1px dashed rgba(217, 48, 37, 0.4);
  padding: 2px 6px;
  border-radius: 4px;
  font-family: inherit;
  font-size: 0.9em;
  word-break: break-all;
}

/* 数学公式错误样式 */
.math-error {
  color: #ff6b6b;
  background: rgba(255, 107, 107, 0.1);
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  border: 1px solid rgba(255, 107, 107, 0.3);
}

/* 提升层级，避免被其他浮层遮挡 */
.response-content { position: relative; }
.solve-stream { position: relative; z-index: 4; }

/* 解题模式下的 LoadingOverlay 样式调整 */
.loading-overlay.solve-mode {
  background-color: rgba(12, 16, 29, 0.85);
  backdrop-filter: blur(2px);
}

.loading-overlay.solve-mode .loading-brand {
  /* display: none !important; */
  color: #fff;
}

.loading-overlay.solve-mode .loading-overlay-content {
  gap: 1rem;
} 